import { render, staticRenderFns } from "./ReportContact.vue?vue&type=template&id=51d8e245"
import script from "./ReportContact.vue?vue&type=script&lang=ts"
export * from "./ReportContact.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports